// Platform checks that change what the UI has to say, rather than what it does.

/**
 * Whether this is an iPhone or iPad.
 *
 * The touch-point half of the test is for iPadOS 13 and up, which reports itself as a Mac and is
 * otherwise indistinguishable from a desktop Safari — `maxTouchPoints` is what gives it away.
 * `navigator.platform` is deprecated but is still the only thing that reports 'MacIntel' there,
 * and it stays populated for exactly this kind of check.
 *
 * Read once at import: neither the device nor its user agent changes mid-session.
 */
export const isIOS =
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

/**
 * Whether the main input is a mouse or trackpad — a desktop, in practice. Stands in for "has a real
 * keyboard", which can't be detected: phones and tablets report a coarse pointer, and those are
 * where focusing a field throws up an on-screen keyboard.
 */
export const hasFinePointer =
  typeof window !== 'undefined' && Boolean(window.matchMedia?.('(pointer: fine)').matches);
